import { Component, Input } from '@angular/core';
import { DashboardHighlightCardComponent } from '../dashboard-highlight-card/dashboard-highlight-card.component';
import { DashboardMetricCardComponent } from '../dashboard-metric-card/dashboard-metric-card.component';
import {
  DashboardHighlightMetric,
  DashboardMetricCard,
} from '../../../../shared/models/interfaces/dashboard/dashboard.interface';

@Component({
  selector: 'l-dashboard-metrics-grid',
  standalone: true,
  imports: [DashboardHighlightCardComponent, DashboardMetricCardComponent],
  templateUrl: './dashboard-metrics-grid.component.html',
})
export class DashboardMetricsGridComponent {

  @Input({ required: true })
  public highlight!: DashboardHighlightMetric;

  @Input({ required: true })
  public metrics: DashboardMetricCard[] = [];

}
